export const SEARCH_DATE_DROPDOWN_DATE_RANGE = {
  YEAR: 'year',
  MONTH: 'month',
  WEEKEND: 'weekend',
  NEXT_WEEKEND: 'nextWeekend',
  WEEK: 'week',
  NEXT_WEEK: 'nextWeek',
  TODAY: 'today',
  CUSTOM: 'custom',
} as const;

export type SearchDateDropdownType =
  typeof SEARCH_DATE_DROPDOWN_DATE_RANGE[keyof typeof SEARCH_DATE_DROPDOWN_DATE_RANGE];
